/// <reference lib="dom" />
import { useState } from "hono/jsx/dom";
import { EULA_TEXT } from "../constants.ts";
import { marked } from "marked";

export function EulaPageContent() {
  const [checked, setChecked] = useState(false);

  async function handleAccept() {
    if (!checked) return;
    try {
      const res = await fetch("/api/legal/accept", { method: "POST" });
      if (res.ok) {
        // Redirect to home
        globalThis.location.href = "/";
      }
    } catch (_e) {
      alert("Failed to accept EULA");
    }
  }

  return (
    <div className="container mx-auto max-w-2xl p-4 mt-10">
      <div className="card bg-base-100 shadow-xl">
        <div className="card-body">
          <h2 className="card-title">End User License Agreement</h2>

          <div className="py-4 h-96 overflow-y-auto text-sm border p-4 rounded bg-base-200">
            <div
              className="prose prose-sm max-w-none"
              dangerouslySetInnerHTML={{
                __html: marked.parse(EULA_TEXT) as string,
              }}
            />
          </div>

          <div className="form-control">
            <label className="cursor-pointer label justify-start gap-4">
              <input
                type="checkbox"
                className="checkbox checkbox-primary"
                checked={checked}
                onChange={(e: Event) =>
                  setChecked((e.target as HTMLInputElement).checked)}
              />
              <span className="label-text">
                I agree to the End User License Agreement
              </span>
            </label>
          </div>

          <div className="card-actions justify-end mt-4">
            <button
              type="button"
              className="btn btn-primary w-full"
              disabled={!checked}
              onClick={handleAccept}
            >
              Accept & Enter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
